import React, { useEffect, useRef } from "react";

/**
 * Terminal — accepts an array of {type:'cmd'|'out'|'err'|'ok', text} lines.
 * Auto-scrolls. Includes scanlines + blinking caret prompt.
 */
const Terminal = ({ lines = [], prompt = "csx@recon-01 ~$", height = "h-72" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [lines]);

  const colorFor = (line) => {
    const t = line.text || "";
    if (line.type === "cmd") return "text-cyan-300";
    if (line.type === "err" || t.startsWith("[!]")) return "text-rose-400";
    if (line.type === "ok" || t.startsWith("[✓]") || t.startsWith("[+]")) return "text-emerald-400";
    if (t.startsWith("[*]")) return "text-amber-300";
    return "text-slate-300";
  };

  return (
    <div
      data-testid="terminal"
      className={`scanline relative bg-black/80 border border-slate-800 rounded-sm font-mono text-[12.5px] leading-relaxed ${height} overflow-y-auto`}
      ref={ref}
    >
      <div className="px-4 py-3">
        {lines.length === 0 && (
          <div className="text-slate-600">
            <span className="text-rose-400">{prompt}</span>{" "}
            <span className="text-slate-500">type a command or trigger an action</span>
            <span className="blink text-cyan-400">▌</span>
          </div>
        )}
        {lines.map((l, i) => (
          <div key={`${i}-${l.type}-${(l.text || "").slice(0, 32)}`} className={colorFor(l)}>
            {l.type === "cmd" && <span className="text-rose-400">{prompt} </span>}
            {l.text}
          </div>
        ))}
        {lines.length > 0 && lines[lines.length - 1]?.type !== "live" && (
          <div className="text-cyan-300">
            <span className="text-rose-400">{prompt} </span>
            <span className="blink">▌</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Terminal;
